import { Injectable } from '@angular/core';

import gsap, { Back, Expo, Power2 } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

@Injectable({ providedIn: 'root' })
export class GsapService {
  constructor() {
    gsap.registerPlugin(ScrollTrigger);
  }

  createScrollTrigger(vars: ScrollTrigger.StaticVars): ScrollTrigger {
    return ScrollTrigger.create(vars);
  }

  easeInOut(): gsap.BackConfig {
    return Back.easeInOut;
  }

  expo(): gsap.Ease {
    return Expo;
  }

  fromTo(targets: gsap.TweenTarget, fromVars: gsap.TweenVars, toVars: gsap.TweenVars): gsap.core.Tween {
    return gsap.fromTo(targets, fromVars, toVars);
  }

  power2(): gsap.Ease {
    return Power2;
  }

  set(targets: gsap.TweenTarget, vars: gsap.TweenVars): gsap.core.Tween {
    return gsap.set(targets, vars);
  }

  timeline(): gsap.core.Timeline {
    return gsap.timeline();
  }
}
